import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useContext } from "react";
import "./simpleTemplate.css";
import AlertMessage from "../shared/alertMessage";
import {LanguageContext, translateText} from '../shared/language'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


function SimpleTemplate({ result, titleProps, columnsProps }) {
  const [dataSet, setDataSet] = useState([]);
  const [title, setTitle] = useState("");
  const [columns, setColumns] = useState(null);
  const { dictionary, userLanguage } = useContext(LanguageContext);

  useEffect(() => {
    setDataSet(result?.data_set);
    setTitle(titleProps);
    setColumns(columnsProps)
  }, [result, titleProps, columnsProps]);


  const exportAsExcelFile=() =>{
    var dataSetDownload = [];
    dataSet.forEach((row, rownumber)=>{
      dataSetDownload.push(row);
      Object.keys(row).forEach((column, index)=>{
        if (column.indexOf('#')>0) {
          Object.defineProperty(dataSetDownload[rownumber],  formatTitlesWithoutCustomization(column, index),
              Object.getOwnPropertyDescriptor(dataSetDownload[rownumber], column));
          delete dataSetDownload[rownumber][column];
      }
      })
    })
    const json =  dataSetDownload;
    const excelFileName = translateText(title,userLanguage);
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer= XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAsExcelFile(excelBuffer, excelFileName);
  }
  const saveAsExcelFile=(buffer, fileName)=> {
     const data = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + new  Date().getTime() + EXCEL_EXTENSION);
  }


  const formatTitlesWithoutCustomization = (title, index) => {
    var customPosition = title.indexOf("#");
    if (customPosition > 0) {
      if(columns){
        return columns[userLanguage][index] || title.substring(0, customPosition)
      }
      else {
        return title.substring(0, customPosition);
      }
    }
    if(columns){
      return columns[userLanguage][index] || title;
    }
    else {
      return title
    }
  };

  const formatInput = (title) => {
    var customPosition = title.indexOf("#");
    if (customPosition > 0) {
      return title.substring(customPosition + 1, title.length);
    }
    return "col-4";
  };
  return (
    <>
      {dataSet && dataSet.length > 0 && (
        <>
          <form style={{ marginBottom: "1rem" }}>
            <div className="card_detail">
              <div className="titulo__contenedor">
                <h2>{translateText(title,userLanguage)}</h2>
                <div className="titulo__acciones" onClick={exportAsExcelFile}>
                  <FontAwesomeIcon icon="cloud-download-alt" />
                  <span>{dictionary.textoDescarga}</span>
                </div>
              </div>
              <hr />
              <div className="row g-3">
                {Object.keys(dataSet[0]).map((key, index) => (
                  <>
                    <div
                      className={formatInput(key) + " parametro__contenedor"}
                    >
                      <p className="parametro__etiqueta">
                        {formatTitlesWithoutCustomization(key, index)}
                      </p>
                      <p className="parametro__valor">{dataSet[0][key]}</p>
                    </div>
                    <hr />
                  </>
                ))}
              </div>
            </div>
          </form>
          {/* <p style={{color:'lightgrey', fontSize: '1rem', textAlign:'right'}}>Consulta ejecutada en {duration}ms</p> */}
        </>
      )}
      {dataSet.length === 0 && (
       <>
       <div className="titulo__contenedor">
         <h2>{titleProps}</h2>
       </div>
       <AlertMessage
          title={dictionary.tituloAlertaSinDatos}
          description={dictionary.descripcionAlertaSinDatos}
        />
     </>
      )}
    </>
  );
}

export default SimpleTemplate;
